import { Outlet, useLocation } from "react-router";
import BottomNav from "./BottomNav";
import Fab from "./Fab";

const FAB_CONFIG: Record<string, { to: string; label: string }> = {
  "/": { to: "/expenses/new", label: "Agregar gasto" },
  "/expenses": { to: "/expenses/new", label: "Agregar gasto" },
  "/transfers": { to: "/transfers/new", label: "Agregar transferencia" },
  "/savings": { to: "/savings/new", label: "Agregar movimiento" },
};

export default function Layout() {
  const { pathname } = useLocation();
  const fab = FAB_CONFIG[pathname];

  return (
    <div className="flex min-h-svh flex-col">
      <main className="flex-1 pb-16">
        <Outlet />
      </main>

      {fab && <Fab to={fab.to} label={fab.label} />}
      <BottomNav />
    </div>
  );
}
